import { IBangDiemSinhVienSelectRequest } from "../../../model/request/in-bang-diem/IBangDiemSinhVienSelectRequest"
import { IBangDiemSinhVienResponse } from "../../../model/response/in-bang-diem/IBangDiemSinhVienResponse"
import { generateActions } from "../../actions/generateActions"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export interface IInBangDiemActionTypesBase<T> {
    request: IBangDiemSinhVienSelectRequest,
    data: T
}

export const eInBangDiemActionsObj = {
    INI_START: {} as IBangDiemSinhVienSelectRequest,
    LOAD_BANG_DIEM_START: {} as IBangDiemSinhVienSelectRequest,
    LOAD_BANG_DIEM_SUCCESS: {} as IInBangDiemActionTypesBase<IBangDiemSinhVienResponse>,
    LOAD_BANG_DIEM_ERROR: {} as IInBangDiemActionTypesBase<string>,

    CHANGE_SELECTED_IDS: {} as number[],
    RESET_STATUS: {} as IBangDiemSinhVienSelectRequest,
}
export const eInBangDiemActionIds = generateActionTypeIds(eInBangDiemActionsObj,"IN_BANG_DIEM");
export type IInBangDiemActionTypes = IGenericActionType<typeof eInBangDiemActionsObj, "IN_BANG_DIEM">;
